import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const INSPECTION_BASE = config.api.REACT_APP_SPED_NORMATIVE_API_URL;

const apiClient = new APIClient();

const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

export const getBreachTypeOfEvidenceList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_BREACH_TYPES_OF_EVIDENCE}?${stringifyParams(
			queryParams
		)}`
	);
};

export const getBreachTypeOfEvidenceListQuery = params => {
	return apiClient.get(
		`${INSPECTION_BASE}${url.GET_BREACH_TYPES_OF_EVIDENCE}?${stringifyParams(params)}`
	);
};

export const getBreachTypeOfEvidenceById = id => {
	return apiClient.get(`${INSPECTION_BASE}${url.GET_BREACH_TYPE_OF_EVIDENCE}${id}`);
};

export const addNewBreachTypeOfEvidenceApi = breachTypeOfEvidence => {
	return apiClient.create(
		`${INSPECTION_BASE}${url.POST_BREACH_TYPE_OF_EVIDENCE}`,
		breachTypeOfEvidence
	);
};

export const updateBreachTypeOfEvidenceApi = breachTypeOfEvidence => {
	return apiClient.put(
		`${INSPECTION_BASE}${url.PUT_BREACH_TYPE_OF_EVIDENCE}${breachTypeOfEvidence._id}`,
		breachTypeOfEvidence
	);
};

export const deleteBreachTypeOfEvidenceApi = id => {
	return apiClient.delete(
		`${INSPECTION_BASE}${url.DELETE_BREACH_TYPE_OF_EVIDENCE}${id}`
	);
};

export const checkBreachTypeOfEvidenceExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${INSPECTION_BASE}${url.CHECK_BREACH_TYPE_OF_EVIDENCE_EXISTS}?${stringifyParams(
				queryParams
			)}`
		)
		.then(response => ({ exists: response && response.length > 0 }))
		.catch(() => ({ exists: false }));
};
